import React, { useRef, useState } from "react";
import Body from "./components/body/Body";
import { ThemeProvider } from "@material-tailwind/react";
import { FooterQuestion } from "./components/footer-question/FooterQuestion";
import { LanguageProvider } from "./i18n";
 



const App = () => {
  const contactSectionRef = useRef(null);
  return (
    <ThemeProvider>
    <LanguageProvider>
      <Body contactSectionRef={contactSectionRef} />
      <FooterQuestion contactSectionRef={contactSectionRef}/>
    </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;



 